import { PreCollection } from '@/resource/pre-collection/pre-collection.model';

const generatePrecollectionName = (preCollection: PreCollection) => {
  return (
    preCollection.subject.name.trim() +
    ' ' +
    preCollection.name.trim() +
    ' ' +
    preCollection.year
  );
};

export default generatePrecollectionName;
